const OKTA_CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID;

export const oktaConfig = {
  issuer: process.env.REACT_APP_OKTA_DOMAIN || "",
  clientId: OKTA_CLIENT_ID,
  redirectUri: window.location.origin + "/login/callback",
  scopes: ["openid", "profile", "email"],
};
